import { ChevronRightIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { Link } from 'react-router-dom';

export interface ResourceCrumb {
    label: string;
    /** Omitted on the last crumb: the current page is text, not a link. */
    to?: string;
}

/** Detail-page path strip: muted links, chevrons, current page bold and truncated. */
export const ResourceBreadcrumb: React.FC<{ crumbs: ResourceCrumb[] }> = ({ crumbs }) => (
    <nav
        aria-label="Breadcrumb"
        className="flex items-center gap-1.5 text-[13px] text-gray-500 min-w-0"
    >
        {crumbs.map((crumb, index) => (
            <React.Fragment key={`${crumb.label}-${index}`}>
                {index > 0 && <ChevronRightIcon className="h-3 w-3 text-gray-300 flex-shrink-0" />}
                {crumb.to ? (
                    <Link
                        to={crumb.to}
                        className="hover:text-gray-800 transition-colors flex-shrink-0"
                    >
                        {crumb.label}
                    </Link>
                ) : (
                    <span className="font-semibold text-gray-700 truncate">{crumb.label}</span>
                )}
            </React.Fragment>
        ))}
    </nav>
);

export default ResourceBreadcrumb;
